export function AdminInvites({ invites }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Einladungen ({invites.length})</h2>
      <div className="bg-gray-800 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-700">
            <tr>
              <th className="text-left px-4 py-3">Eingeladene Email</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Datum</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {invites.map((inv) => (
              <tr key={inv.id} className="hover:bg-gray-700/50">
                <td className="px-4 py-3">{inv.email}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-1 rounded text-xs ${
                    inv.status === 'accepted' 
                      ? 'bg-green-500/20 text-green-400'
                      : 'bg-yellow-500/20 text-yellow-400'
                  }`}>
                    {inv.status === 'accepted' ? 'Angenommen' : 'Ausstehend'}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-400">
                  {new Date(inv.created_at).toLocaleDateString('de-DE')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {invites.length === 0 && (
          <div className="text-gray-400 p-4">Noch keine Einladungen</div>
        )}
      </div>
    </div>
  );
}
